var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"password-page"},[(_vm.mode === 'requestNew')?_c('new-password-request-form'):_vm._e(),_vm._v(" "),(_vm.mode === 'reset')?_c('new-password-form',{attrs:{"code":_vm.code}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }